import getData, { postData } from "@/__main__/get-data.mjs";
import noopModel from "@/data-models/no-op.mjs";
import type { FactionBE, GameMode } from "@/game-eft/constants/constants.mjs";
import type {
  CreatePlayerSeasonStatInput,
  UpdatePlayerSeasonStatInput,
} from "@/game-eft/models/graphql.mjs";
import { PlayerSeasonStatValidate } from "@/game-eft/models/graphql.mjs";
import * as API from "@/game-eft/utils/api.mjs";
import getPlayerSeasonStatKeyState from "@/game-eft/utils/get-player-season-stat-keystate.mjs";

export default async function fetchPlayerSeasonStat({
  profileId,
  gameMode,
  faction,
}: {
  profileId: string;
  gameMode: GameMode.ARENA | GameMode.DEFAULT;
  faction: FactionBE;
}): Promise<void> {
  await getData(
    API.getPlayerSeasonStat({ accountId: profileId, gameMode, faction }),
    PlayerSeasonStatValidate,
    [
      "eft",
      "playerSeasonStat",
      getPlayerSeasonStatKeyState(profileId, gameMode, faction),
    ],
    {
      shouldFetchIfPathExists: true,
      skipSafetyCheck: true,
      networkBackOffTime: 0,
    },
  );
}

export async function createPlayerSeasonStat(
  payload: CreatePlayerSeasonStatInput,
): Promise<void> {
  await postData(
    API.createPlayerSeasonStats({ playerSeasonStat: payload }),
    noopModel,
    undefined,
  );
}

export async function updatePlayerSeasonStat(
  payload: UpdatePlayerSeasonStatInput,
): Promise<void> {
  await postData(
    API.updatePlayerSeasonStats({ playerSeasonStat: payload }),
    noopModel,
    undefined,
  );
}
